export const SET_EVENT_DATA = 'SET_EVENT_DATA';
